module.exports = __webpack_public_path__ + "img/modalBg.557ea891.jpg";